import React from 'react'
import { Input } from '@fluentui/react-components'
import { t } from '../../../i18n/i18n'
import { Control, Controller } from 'react-hook-form'
import './resetInput.css'
import { Field } from './Field'
import { formatToSwedishCrowns } from '../../../helpers/stringHelper'

type ControlledMoneyInputProps = {
   name: any
   control: Control<any>
   label?: string
   disabled?: boolean
   required?: boolean
}
export const ControlledMoneyInput = ({ name, control, label, disabled, required }: ControlledMoneyInputProps) => {
   return (
      <Controller
         name={name}
         control={control}
         rules={{ required: required ? t('RequiredField') : false, pattern: /^[0-9]+$/ }}
         render={({ field: { value, onChange }, fieldState: { error, invalid }, formState: { disabled: formDisabled } }) => {
            const formattedValue = value === null || value === undefined ? '' : formatToSwedishCrowns(value)

            return (
               <Field label={label} required={required ?? false} validationMessage={error ? error.message : null} validationState={error ? 'error' : null}>
                  <Input
                     type="text"
                     value={formattedValue}
                     onChange={(e, data) => {
                        const rawValue = data.value.replace(/\D/g, '')
                        onChange(rawValue === '' ? null : Number(rawValue))
                     }}
                     disabled={disabled || formDisabled ? true : false}
                     contentAfter="kr"
                  />
               </Field>
            )
         }}
      />
   )
}
